import React from 'react';
import { Link } from 'react-router-dom';
// import { Navigation, Pagination, A11y } from 'swiper';

// import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
// import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { useSelector } from 'react-redux';
import Donut from './Donut';
// import { WebUrl } from '../../../BaseUrl';

const AppFrameMain = () => {

    const mobilecategories = useSelector(state => state.SliceData.mobilecategories);
    // const saasclients = useSelector(state => state.SliceData.saasclients);
    const mobilepros = useSelector(state => state.SliceData.mobilepros);

    return (
        <>

            {/* <!-- boxed container starts --> */}

            <section className="boxed-contt">

                <div className="large-too">
                    <span>SERVICES</span>
                </div>
            </section>
            <div className="row app-service-icon">

                {mobilecategories?.map((item, index) => (
                    <div className="col-lg-4 col-md-6" key={index}>
                        <div className="boxed d-flex">
                            <div className="icon-box">
                                {/* <i className="fa-solid fa-pen-ruler"></i> */}
                            </div>
                            <div className="text-box">
                                <h5><Link to="">{item?.title}</Link></h5>
                                <p>{item?.content}</p>
                                <Link to="" className="hover-link"><span className="icon-btn"><i className="fa-solid fa-plus"></i></span>
                                    <span className="btn-infor">Read more</span></Link>
                            </div>
                        </div>
                    </div>
                ))}

            </div>

            {/* <!-- </section> --> */}
            {/* <!-- boxedd container ends --> */}


            {/* <!-- testimonial starts --> */}

            {/* <div className='top-slide-hid'>
                <div className="top-swiper">
                    <div className="data order-2 order-md-2">


                    </div>
                    <div className="heading-2 order-1 order-md-1">
                        <h3>What our client says</h3>
                    </div>
                </div>
                <Swiper
                    
                    modules={[Navigation, Pagination, A11y]}
                    spaceBetween={50}
                    slidesPerView={1}
                    navigation
                    direction="vertical"
                    loop={true}
                    speed={800}
                    pagination={{ clickable: true }}
                   
                    className='swiper'
                    onSwiper={(swiper) => console.log(swiper)}
                    onSlideChange={() => console.log('slide change')}
                >
                   
                    {saasclients?.map((item, index) => (
                    <SwiperSlide className='swiper-slide d-flex flex-md-row flex-column' key={index}>
                        
                        <div className="image-slider ">
                            <img src={`${WebUrl}/${item?.image}`} className="mx-auto" width="146px" alt="" />
                        </div>
                        <div className="slide-text">
                            <p>{item?.review}</p>

                            <h2>{item?.name}</h2>
                        </div>
                       
                    </SwiperSlide>
                    ))}
                  
                </Swiper>
            </div> */}



            {/* <!-- tabs section starts --> */}

            <section className="tab-sec ">
                <div className="container">
                    {/* <div className="main-title text-center">
                        <h2>Website Support We Offer</h2>

                    </div> */}
                    <div className="contact-text web-text my-auto text-center main-title py-80">
                        <div className="head text-center ">
                            <p className="first mx-auto">
                                Achieve your web's full potential
                            </p>
                        </div>
                        <h2>App Support We Offer</h2>
                    </div>
                    <div className="row">
                        <div className="col-lg-12 new-quart px-0">
                            <div className="bg-gr web-men">
                                <nav>
                                    <div className="nav justify-content-around nav-tabs" id="nav-tab" style={{ width: 'auto' }} role="tablist">
                                        <button style={{ width: 'auto' }} className="nav-lin active" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected="true">24/7 Technical Support</button>
                                        <button style={{ width: 'auto' }} className="nav-lin" id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile" aria-selected="false">Performance Optimization</button>
                                        <button style={{ width: 'auto' }} className="nav-lin" id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact" type="button" role="tab" aria-controls="nav-contact" aria-selected="false">Security Enhancements</button>
                                        <button style={{ width: 'auto' }} className="nav-lin" id="nav-speed-tab" data-bs-toggle="tab" data-bs-target="#nav-speed" type="button" role="tab" aria-controls="nav-speed" aria-selected="false">Feature Enhancements</button>
                                        <button style={{ width: 'auto' }} className="nav-lin" id="nav-App-tab" data-bs-toggle="tab" data-bs-target="#nav-App" type="button" role="tab" aria-controls="nav-App" aria-selected="false">App Store Optimization (ASO)</button>
                                        <button style={{ width: 'auto' }} className="nav-lin" id="nav-Analytics-tab" data-bs-toggle="tab" data-bs-target="#nav-Analytics" type="button" role="tab" aria-controls="nav-Analytics" aria-selected="false">Analytics and Reporting</button>
                                        {/* <button className="nav-lin" id="nav-ams-tab" data-bs-toggle="tab" data-bs-target="#nav-ams" type="button" role="tab" aria-controls="nav-ams" aria-selected="false">AMS</button> */}
                                        <div className="animation start-home" id="marker"></div>
                                    </div>
                                </nav>
                            </div>
                            <div className="tab-content px-3" id="nav-tabContent">
                                <div className="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">

                                    <div className="row">
                                        <div className="col-lg-8 order-2 order-lg-1">
                                            <div className="contact-text my-auto py-80">

                                                <p>Our dedicated team ensures round-the-clock availability for addressing technical issues, guaranteeing smooth and efficient app performance.</p>
                                                <div className="consult-address">

                                                    <div className="row">
                                                        <div className="col-lg-6 mb-4">

                                                            <ul>
                                                                <li className="d-flex quick mb-1">
                                                                    <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                    <span className="check-text">Instant technical assistance.</span>
                                                                </li>
                                                                <li className="d-flex quick mb-1">
                                                                    <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                    <span className="check-text">Continuous monitoring for issue detection.</span>
                                                                </li>
                                                                <li className="d-flex quick mb-1">
                                                                    <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                    <span className="check-text">Quick response and resolution times.                                        </span>
                                                                </li>
                                                                <li className="d-flex quick mb-1">
                                                                    <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                    <span className="check-text">Support for app updates and compatibility.                                                 </span>
                                                                </li>


                                                            </ul>
                                                        </div>
                                                        <div className="col-lg-6 mb-4">

                                                            <ul>
                                                                <li className="d-flex quick mb-1">
                                                                    <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                    <span className="check-text">Troubleshooting for performance optimization.                                                 </span>
                                                                </li>
                                                                <li className="d-flex quick mb-1">
                                                                    <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                    <span className="check-text">Proactive maintenance for uninterrupted usage.                                                </span>
                                                                </li>
                                                                <li className="d-flex quick mb-1">
                                                                    <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                    <span className="check-text">Expert guidance on technical challenges.                                              </span>
                                                                </li>
                                                                <li className="d-flex quick mb-1">
                                                                    <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                    <span className="check-text">Reliable support for app stability.                                         </span>
                                                                </li>


                                                            </ul>
                                                        </div>


                                                    </div>
                                                </div>
                                                <Link to="" className="btn btn-new">Read More <i className="fa-solid fa-angle-right ms-1"></i></Link>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 my-auto order-1 order-lg-2">
                                            <div className='w-100'>

                                                <div className=' d-flex justify-content-center saas-img py-3'>

                                                    <img src="assets/Images/technicalSupport.svg" className="img-responsive frame-img" alt="" />

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
                                    <div className="row">
                                        <div className="col-lg-8 order-2 order-lg-1">
                                            <div className="contact-text my-auto py-80 ">

                                                <p>Utilizing continuous monitoring and analysis, we optimize app performance and responsiveness, enhancing user satisfaction and retention.</p>
                                                <div className="consult-address">

                                                    <div className="row">
                                                        <div className="col-lg-6 mb-4">

                                                            <ul>
                                                                <li className="d-flex quick mb-1">
                                                                    <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                    <span className="check-text">Performance monitoring and analysis.                                             </span>
                                                                </li>
                                                                <li className="d-flex quick mb-1">
                                                                    <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                    <span className="check-text">Optimization of app speed and responsiveness.                                                </span>
                                                                </li>
                                                                <li className="d-flex quick mb-1">
                                                                    <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                    <span className="check-text">Resource utilization and efficiency improvements.                                             </span>
                                                                </li>
                                                                <li className="d-flex quick mb-1">
                                                                    <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                    <span className="check-text"> Bug fixing and performance enhancements.                                             </span>
                                                                </li>


                                                            </ul>
                                                        </div>
                                                        <div className="col-lg-6 mb-4">

                                                            <ul>
                                                                <li className="d-flex quick mb-1">
                                                                    <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                    <span className="check-text">Compatibility testing for various devices.                                                </span>
                                                                </li>
                                                                <li className="d-flex quick mb-1">
                                                                    <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                    <span className="check-text">User experience optimization strategies.                                                   </span>
                                                                </li>
                                                                <li className="d-flex quick mb-1">
                                                                    <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                    <span className="check-text">Load testing and scalability improvements.                                     </span>
                                                                </li>
                                                                <li className="d-flex quick mb-1">
                                                                    <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                    <span className="check-text">Continuous performance tuning for efficiency.                                                </span>
                                                                </li>


                                                            </ul>
                                                        </div>


                                                    </div>
                                                </div>
                                                <Link to="" className="btn btn-new">Read More <i className="fa-solid fa-angle-right ms-1"></i></Link>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 my-auto order-1 order-lg-2">
                                            <div className='w-100'>

                                                <div className='saas-img py-3'>

                                                    <img src="assets/Images/performanceOptimize.png" className="img-responsive frame-img" alt="" />

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">
                                    <div className="row">
                                        <div className="col-lg-8 order-2 order-lg-1">
                                            <div className="contact-text my-auto py-80">

                                                <p>Regular audits and robust security measures protect user data and ensure compliance with industry standards.</p>
                                                <div className="consult-address">

                                                    <div className="row">
                                                        <div className="col-lg-6 mb-4">

                                                            <ul>
                                                                <li className="d-flex quick mb-1">
                                                                    <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                    <span className="check-text"> Regular security audits and vulnerability assessments.                               </span>
                                                                </li>
                                                                <li className="d-flex quick mb-1">
                                                                    <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                    <span className="check-text">Implementation of data encryption and secure protocols.                                       </span>
                                                                </li>
                                                                <li className="d-flex quick mb-1">
                                                                    <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                    <span className="check-text">Compliance with privacy regulations.                                                 </span>
                                                                </li>
                                                                <li className="d-flex quick mb-1">
                                                                    <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                    <span className="check-text"> User authentication and access control measures.                                                 </span>
                                                                </li>


                                                            </ul>
                                                        </div>
                                                        <div className="col-lg-6 mb-4">

                                                            <ul>
                                                                <li className="d-flex quick mb-1">
                                                                    <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                    <span className="check-text">Secure data storage and transmission practices.                                     </span>
                                                                </li>
                                                                <li className="d-flex quick mb-1">
                                                                    <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                    <span className="check-text"> Incident response planning and management.                                               </span>
                                                                </li>
                                                                <li className="d-flex quick mb-1">
                                                                    <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                    <span className="check-text">Security patches and updates.</span>
                                                                </li>
                                                                <li className="d-flex quick mb-1">
                                                                    <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                    <span className="check-text">Employee training on security best practices.                                                    </span>
                                                                </li>


                                                            </ul>
                                                        </div>


                                                    </div>
                                                </div>
                                                <Link to="" className="btn btn-new">Read More <i className="fa-solid fa-angle-right ms-1"></i></Link>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 my-auto order-1 order-lg-2">
                                            <div className='w-100'>
                                                <div className='saas-img py-3 d-flex justify-content-center'>
                                                    <img style={{ maxWidth: "70%" }} src="assets/Images/securityEnhance.png" className="img-responsive frame-img" alt="" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="nav-speed" role="tabpanel" aria-labelledby="nav-speed-tab">
                                    <div className="row">
                                        <div className="col-lg-8 order-2 order-lg-1">
                                            <div className="contact-text my-auto py-80">

                                                <p>Regular updates based on feedback, trends, and technology advancements keep your app competitive and user-focused.</p>
                                                <div className="consult-address">

                                                    <div className="row">
                                                        <div className="col-lg-6 mb-4">

                                                            <ul>
                                                                <li className="d-flex quick mb-1">
                                                                    <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                    <span className="check-text">User feedback analysis for feature prioritization.                                     </span>
                                                                </li>
                                                                <li className="d-flex quick mb-1">
                                                                    <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                    <span className="check-text">Continuous feature development and enhancements.</span>
                                                                </li>
                                                                <li className="d-flex quick mb-1">
                                                                    <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                    <span className="check-text">Integration of new technologies and functionalities.</span>
                                                                </li>
                                                                <li className="d-flex quick mb-1">
                                                                    <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                    <span className="check-text">User interface and experience improvements.</span>
                                                                </li>


                                                            </ul>
                                                        </div>
                                                        <div className="col-lg-6 mb-4">

                                                            <ul>
                                                                <li className="d-flex quick mb-1">
                                                                    <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                    <span className="check-text">Customization options and user preferences.                                           </span>
                                                                </li>
                                                                <li className="d-flex quick mb-1">
                                                                    <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                    <span className="check-text">Performance tracking and user engagement analysis.                                              </span>
                                                                </li>
                                                                <li className="d-flex quick mb-1">
                                                                    <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                    <span className="check-text">Beta testing and user acceptance testing.</span>
                                                                </li>
                                                                <li className="d-flex quick mb-1">
                                                                    <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                    <span className="check-text">Iterative development based on user needs.                                             </span>
                                                                </li>


                                                            </ul>
                                                        </div>


                                                    </div>
                                                </div>
                                                <Link to="" className="btn btn-new">Read More <i className="fa-solid fa-angle-right ms-1"></i></Link>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 my-auto order-1 order-lg-2">
                                            <div className='w-100'>

                                                <div className='saas-img py-3 d-flex justify-content-center'>
                                                    <img style={{ maxWidth: "70%" }} src="assets/Images/featuresEnhance.png" className="img-responsive frame-img" alt="" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="nav-Analytics" role="tabpanel" aria-labelledby="nav-Analytics-tab">
                                    <div className="row">
                                        <div className="col-lg-8 order-2 order-lg-1">
                                            <div className="contact-text my-auto py-80">

                                                <p>Comprehensive tools provide insights into user behavior and app performance, supporting data-driven decision-making and continuous improvement strategies.</p>
                                                <div className="consult-address">

                                                    <div className="row">
                                                        <div className="col-lg-6 mb-4">

                                                            <ul>
                                                                <li className="d-flex quick mb-1">
                                                                    <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                    <span className="check-text">User behavior tracking and analysis.                                             </span>
                                                                </li>
                                                                <li className="d-flex quick mb-1">
                                                                    <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                    <span className="check-text">App usage metrics and engagement analytics.                                      </span>
                                                                </li>
                                                                <li className="d-flex quick mb-1">
                                                                    <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                    <span className="check-text">Conversion tracking and funnel analysis.</span>
                                                                </li>
                                                                <li className="d-flex quick mb-1">
                                                                    <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                    <span className="check-text">Performance monitoring and crash reporting.</span>
                                                                </li>


                                                            </ul>
                                                        </div>
                                                        <div className="col-lg-6 mb-4">

                                                            <ul>
                                                                <li className="d-flex quick mb-1">
                                                                    <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                    <span className="check-text">User retention and churn rate analysis.</span>
                                                                </li>
                                                                <li className="d-flex quick mb-1">
                                                                    <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                    <span className="check-text"> A/B testing and experimentation for optimization.                                           </span>
                                                                </li>
                                                                <li className="d-flex quick mb-1">
                                                                    <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                    <span className="check-text">Customized reports and dashboards.                                              </span>
                                                                </li>
                                                                <li className="d-flex quick mb-1">
                                                                    <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                    <span className="check-text">Actionable insights for strategic decision-making.                                                  </span>
                                                                </li>


                                                            </ul>
                                                        </div>


                                                    </div>
                                                </div>
                                                <Link to="" className="btn btn-new">Read More <i className="fa-solid fa-angle-right ms-1"></i></Link>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 my-auto order-1 order-lg-2">
                                            <div className='w-100'>

                                                <div className='saas-img py-3 d-flex justify-content-center'>

                                                    <img src="assets/Images/analyticsAndReport.png" className="img-responsive frame-img" alt="" />

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="nav-App" role="tabpanel" aria-labelledby="nav-App-tab">
                                    <div className="row">
                                        <div className="col-lg-8 order-2 order-lg-1">
                                            <div className="contact-text my-auto py-80">

                                                <p>Strategic techniques improve app visibility and downloads, including keyword optimization and engaging visuals.
                                                </p>
                                                <div className="consult-address">

                                                    <div className="row">
                                                        <div className="col-lg-6 mb-4">

                                                            <ul>
                                                                <li className="d-flex quick mb-1">
                                                                    <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                    <span className="check-text">Keyword research and optimization for app store listings.                                                 </span>
                                                                </li>
                                                                <li className="d-flex quick mb-1">
                                                                    <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                    <span className="check-text">Compelling app descriptions and visuals.
                                                                    </span>
                                                                </li>
                                                                <li className="d-flex quick mb-1">
                                                                    <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                    <span className="check-text">App store category selection and metadata optimization.                                           </span>
                                                                </li>
                                                                <li className="d-flex quick mb-1">
                                                                    <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                    <span className="check-text">User ratings and reviews management.                                </span>
                                                                </li>


                                                            </ul>
                                                        </div>
                                                        <div className="col-lg-6 mb-4">

                                                            <ul>
                                                                <li className="d-flex quick mb-1">
                                                                    <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                    <span className="check-text">Competitive analysis and benchmarking. </span>
                                                                </li>
                                                                <li className="d-flex quick mb-1">
                                                                    <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                    <span className="check-text"> App promotion and marketing strategies.                                             </span>
                                                                </li>
                                                                <li className="d-flex quick mb-1">
                                                                    <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                    <span className="check-text">Localization for global app store reach.                                               </span>
                                                                </li>
                                                                <li className="d-flex quick mb-1">
                                                                    <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                    <span className="check-text"> Monitoring and optimizing app store rankings.                                         </span>
                                                                </li>


                                                            </ul>
                                                        </div>


                                                    </div>
                                                </div>
                                                <Link to="" className="btn btn-new">Read More <i className="fa-solid fa-angle-right ms-1"></i></Link>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 my-auto order-1 order-lg-2">
                                            <div className='w-100'>

                                                <div className='saas-img py-3 d-flex justify-content-center'>

                                                    <img src="assets/Images/AppStoreOpti.jpeg" className="img-responsive frame-img" alt="" />

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="tab-pane fade" id="nav-ams" role="tabpanel" aria-labelledby="nav-ams-tab">
                                        <div className="row">
                                            <div className="col-lg-8 order-2 order-lg-1">
                                                <div className="contact-text my-auto py-80">

                                                    <p>Vulputate cursus a sit amet maur is. Morbi accumsan ipsum velit. Nam nec tellus a odio tincidunt auctor a ornare. Lorem Ipsum aenean commo dolig. Proin qual de suis erestopius. liqueenean sollicituin. lorem quis bibendum auct ornisi elit consequat ipsum, nec sagittis sem nibh id elit. </p>
                                                    <div className="consult-address">

                                                        <div className="row">
                                                            <div className="col-lg-6 mb-4">

                                                                <ul>
                                                                    <li className="d-flex quick mb-1">
                                                                        <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                        <span className="check-text">Proin qual de suis erestopius                                                    </span>
                                                                    </li>
                                                                    <li className="d-flex quick mb-1">
                                                                        <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                        <span className="check-text">Proin qual de suis erestopius                                                    </span>
                                                                    </li>
                                                                    <li className="d-flex quick mb-1">
                                                                        <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                        <span className="check-text">Proin qual de suis erestopius                                                    </span>
                                                                    </li>
                                                                    <li className="d-flex quick mb-1">
                                                                        <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                        <span className="check-text">Proin qual de suis erestopius                                                    </span>
                                                                    </li>


                                                                </ul>
                                                            </div>
                                                            <div className="col-lg-6 mb-4">

                                                                <ul>
                                                                    <li className="d-flex quick mb-1">
                                                                        <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                        <span className="check-text">Proin qual de suis erestopius                                                    </span>
                                                                    </li>
                                                                    <li className="d-flex quick mb-1">
                                                                        <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                        <span className="check-text">Proin qual de suis erestopius                                                    </span>
                                                                    </li>
                                                                    <li className="d-flex quick mb-1">
                                                                        <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                        <span className="check-text">Proin qual de suis erestopius                                                    </span>
                                                                    </li>
                                                                    <li className="d-flex quick mb-1">
                                                                        <span className="check-icon"><i className="fa-regular me-2 fa-square-check"></i></span>
                                                                        <span className="check-text">Proin qual de suis erestopius                                                    </span>
                                                                    </li>


                                                                </ul>
                                                            </div>


                                                        </div>
                                                    </div>
                                                    <Link to="" className="btn btn-new">Read More <i className="fa-solid fa-angle-right ms-1"></i></Link>
                                                </div>
                                            </div>

                                            <div className="col-lg-4 my-auto order-1 order-lg-2">
                                                <div className='w-100'>

                                                    <div className='saas-img py-3'>

                                                        <img src="assets/Images/all.png" className="img-responsive frame-img" alt="" />

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}
                            </div>
                        </div>
                        {/* <div className="col-lg-4 py-90 px-50">
                <div id="myChart">
<Donut/>
                </div>
            </div> */}
                    </div>
                </div>

            </section>


            {/* <!-- tabs section ends --> */}
            {/* <!-- Swiper ends --> */}


            {/* <!-- process starts --> */}

            <section className="process py-80">
                <div className="container">
                    <div className="main-title text-center">
                        <h2>Our Process</h2>

                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="process-img">
                                <img width="100%" src="assets/Images/Home-4-phone-img.png" alt="" />
                            </div>
                        </div>
                        <div className="col-lg-6 pt-5">

                            {mobilepros?.map((item, index) => (
                                <div className="row" key={index}>
                                    <div className="col-3">
                                        <div className="process-left">
                                            <div className="process-number">
                                                0{index + 1}
                                            </div>
                                            <div className="process-line"></div>
                                        </div>
                                    </div>

                                    <div className="col-9 p-3">
                                        <div className="process-txt">
                                            <h5>{item?.title}</h5>
                                            <p>{item?.content}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}

                        </div>
                    </div>
                </div>

            </section>

            {/* <!-- process ends --> */}

        </>
    )
}

export default AppFrameMain